import { Modal } from "react-bootstrap";
import { ReactComponent as Status } from "../../asset/images/status.svg";

const UnMapModal = ({ show, onClose, isLoading, onUnmap }) => {
  return (
    <Modal className="idu-modal" show={show} onHide={onClose} centered>
      <Modal.Body>
        <div className="d-flex flex-column align-items-center unmap-modal-div">
          <Status />

          <span>Unmap Telecaller User ID?</span>

          <p className="text-center">
            This will remove the currently assigned Telecaller User ID from this
            record. You can assign a new one later if needed
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="idu-btn-outline w-50"
          type="button"
          onClick={onClose}
        >
          CANCEL
        </button>
        <button
          className="idu-btn-primary w-50"
          type="button"
          onClick={onUnmap}
        >
          {isLoading ? "LOADING..." : "UNMAP"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnMapModal;
